<template>
  <div class="editor-chunk">
    <div class="int-chunk border-1px">
      <input type="text" class="int-editor-txt" placeholder="给自己的口味起个响亮的名字" autofocus
             :maxlength="maxLength"
             v-model.trim="potCustomName">
      <span class="iconfont icon-close limitLen" @click="clearTxt"></span>
    </div>
    <button class="btn-editor-confirm" @click="intConfirm">保存</button>
  </div>
</template>
<script>
  import {Toast} from 'mint-ui';
  import {add, getPrivatePot} from './../config/api.js';
  import ajax from '../../../pub/utils/ajaxUtils.js';

  export default {
    methods: {
      clearTxt() {
        this.potCustomName = '';
      },
      // 详情--为了获取手机号码
      getPrivatePot() {
        let params = {
          dishDetailId: this.propsInfo.id,
          privateCustomId: this.propsInfo.privateCustomId || '',
        };
        ajax.postJson(getPrivatePot, params,
          data => {
          let _obj = data.obj;
            this.potCustomName = _obj.potName;
            this.propsInfo.name = _obj.memberName;
            this.propsInfo.shopName = _obj.nickName;
            this.$set(this.propsInfo, 'phone', data.obj.phone);
            this.$set(this.propsInfo, 'dishListDetailId', data.obj.dishListDetailId);
            this.propsInfo.phone = data.obj.phone;
            this.propsInfo.dishListDetailId = data.obj.dishListDetailId;
            this.propsInfo.privateCustomId = data.obj.privateCustomId;
            sessionStorage.setItem('p', JSON.stringify(this.propsInfo));
          }
        );
      },
      intConfirm() {
        if (!this.potCustomName && this.potCustomName !== 0) {
          Toast({
            message: '请输入名字',
            position: 'top',
            duration: 2000
          });
          return;
        }
        this.propsInfo = Object.assign(this.propsInfo, JSON.parse(sessionStorage.getItem('p')));
        for (let k in this.potTypeCode) {
          if (k === this.propsInfo.dishCode) this.propsInfo.potType = this.potTypeCode[k];
        }
        let params = this.propsInfo;
        params.potCustomName = this.potCustomName;// 定制名称
        params.privateCustomId = this.propsInfo.privateCustomId || '';// 主键id
        params.flag = 'save';// 保存时传
        /*let params = {
          companyId: this.propsInfo.companyId,// 公司ID
          shopId: this.propsInfo.shopId,// 门店id
          tableBillId: this.propsInfo.tableBillId,// 账单id
          potRelateId: this.propsInfo.dishStandardId,// 锅底id(对应dishStandardId)
          dishListDetailId: this.propsInfo.id,// 菜品明细id
          customTime: this.propsInfo.orderTime,// 下菜时间 -- orderTime
          spicerId: this.propsInfo.waiterId,// 服务员ID--waiterId
          memberId: this.propsInfo.memberId,// 会员id
          phone: this.propsInfo.phone,// 手机号
          potCustomName: this.potCustomName,// 定制名称
          id: '' || this.propsInfo.privateCustomId,// 主键id
          dishPrice: this.propsInfo.dishPrice,// 锅底价格
          practice: this.propsInfo.practice,
          flag: 'save',// 保存时传
          potType: this.potType,
        };*/
        ajax.postJson(add, params,
          data => {
            if (data.result === 200) {
              /*if (this.propsInfo.shopId === 'D9665D8A40000000A000000000140010') {
                let mes = JSON.parse(data.message);
                this.propsInfo.privateCustomId = mes.id;// 主键id
                this.propsInfo.potCustomName = this.potCustomName;
                sessionStorage.setItem('p', JSON.stringify(this.propsInfo));
                this.$router.push({
                  name: 'share',
                  query: {privateCustomId: this.propsInfo.privateCustomId, dishDetailId: this.propsInfo.id}
                });
              }
              else {*/
                let mes = JSON.parse(data.message);
                if ( mes && mes.success ) {
                  Toast({
                    message: '保存成功',
                    position: 'top',
                    duration: 1500
                  });
                  window.location.href = mes.url;
                } else {
                  Toast({
                    message: '该口味已命名分享',
                    position: 'top',
                    duration: 1500
                  });
                }
              // }
              /*this.propsInfo.privateCustomId = data.obj.id;// 主键id
              this.propsInfo.potCustomName = this.potCustomName;
              sessionStorage.setItem('p', JSON.stringify(this.propsInfo));
              this.$router.push({
                name: 'share',
                query: {privateCustomId: this.propsInfo.privateCustomId, dishDetailId: this.propsInfo.id}
              });*/
            }
            else {
              Toast({
                message: data.message,
                position: 'top',
                duration: 1500
              });
            }
          }
        )
      },
    },
    data() {
      return {
        maxLength: 30,
        propsInfo: {
          companyId: '',// 公司ID
          shopId: '',// 门店id
          tableBillId: '',// 账单id
          dishStandardId: '',// 锅底id
          dishListDetailId: '',// 菜品明细id
          orderTime: '',// 下菜时间
          waiterId: '',// 服务员ID
          memberId: '',// 会员id
          phone: '',// 手机号
          privateCustomId: '',// 主键id
          potCustomName: '',// 定制名称
          potType: '',// 对应锅底
          name: '',// 会员名称
          shopName: '',// 门店别名
        },
        potCustomName: '',// 定制名称
        /*
        * 对应锅底
        * 1 -- 牛油麻辣/01060064
        * 2 -- 清油麻辣/01060061
        * 3 -- 番茄火锅/01060066
        * 4 -- 辣炫风火锅/01060228
        * */
        potTypeCode: {
          '01060064': 1,
          '01060061': 2,
          '01060066': 3,
          '01060228': 4,
        },
      }
    },
    created() {
      this.propsInfo = Object.assign(this.propsInfo, JSON.parse(sessionStorage.getItem('p')));
      this.potCustomName = this.propsInfo.dishName;
      this.getPrivatePot();
    }
  }
</script>
<style lang="stylus" scoped>
  @import '../../../assets/css/func.styl'
  textarea::-webkit-input-placeholder
    color: #9a9a9a
    font-size: .29rem
  textarea::-moz-placeholder
    color: #9a9a9a
    font-size: .29rem
  textarea:-moz-placeholder
    color: #9a9a9a
    font-size: .29rem
  textarea:-ms-input-placeholder
    color: #9a9a9a
    font-size: .29rem
  .editor-chunk
    background: #f7f7f7
    padding-top: 1rem
    .int-chunk
      //b_t_b-1px(#e9e9e9)
      border-x(#e9e9e9, 2px, 2px)
      background: #fff
      font-size: 0.3rem
      .int-editor-txt
        display: block
        resize: none
        outline: none
        box-sizing: border-box
        width: 95%
        height: .8rem
        padding: 0.2rem .22rem
        border: none
      .limitLen
        position absolute
        top: .25rem
        right: .22rem
        font-size: 0.3rem
        color: #9a9a9a
    .btn-editor-confirm
      display: block
      width: 6.76rem
      height: .88rem
      margin: .3rem auto 0
      background: #ff6071
      font-size: 0.36rem
      border: none
      border-radius: .08rem
      color: #fff
</style>


// WEBPACK FOOTER //
// src/components/share/editor/editor.vue